import Contributor from './contributor';
import { act, deact, createOrUpdate } from '../../../services/lwadmin/partnership/partnership-service';

export default class Partnership {
  /* eslint-disable camelcase */
  constructor(source) {
    Object.assign(this, source || {
      id: null,
      name: '',
      active: true,
      account_manager: null,
      send_automatically: true,
      contact_email: '',
      partnership_type: 'Silver',
      dashboard_url: '',
      sent_contact_count: 0,
      unsent_contact_count: 0,
      contributors: [],
      companies: [],
    });

    this.contributors = this.contributors || [];

    this.contributors = this.contributors.map(c => new Contributor(c));

    this.companies = this.companies || [];
  }

  get total_contact_count() {
    return this.sent_contact_count + this.unsent_contact_count;
  }

  activate() {
    return act(this.id).then(() => {
      this.active = true;
    });
  }

  deactivate() {
    return deact(this.id).then(() => {
      this.active = false;
    });
  }

  save() {
    return createOrUpdate(this);
  }
  /* eslint-enable camelcase */
}
